import React from "react";

export const ArticleCard = ({ article, editable = false }) => {
  const state = {
    editable: editable,
    title: article.title,
    isDraft: article.is_draft,
    authorId: article.user_id,
    href: article.href,
    author: article.author,
    author_thumb: article.author_thumb,
    author_profile: article.author_profile,
    editUrl: `/write/${article.type}/${article.id}`,
    prePublishUrl: `/write/${article.id}/pre-publish`,
    unPublishUrl: `/write/${article.id}/unpublish`,
    deleteUrl: `/write/${article.id}/delete`,
    spotlightUrl: article.thumbnail,
    vehicle: article.vehicle,
    commentCount: article.comments,
    contestUrl: article.contest_url,
    locked: article.locked,
  };

  const onDeleteClick = () => {
    return confirm(`Delete ${state.title} Forever?`);
  };

  var comments,
    deleteButton,
    draftFlag,
    editButton,
    lockedButton,
    publishButton,
    unPublishButton;

  let articleClasses =
    "article-card " + (state.isDraft ? "draft" : "published");
  if (state.contestUrl) {
    articleClasses += " in-contest";
  }
  if (state.commentCount > 0) {
    comments = (
      <div className="comments">
        <span>comments: </span>
        <span>{state.commentCount}</span>
      </div>
    );
  }
  if (state.editable) {
    articleClasses += " editable";
    if (state.locked) {
      lockedButton = <span className="edit">Locked - not editable</span>;
    } else {
      editButton = (
        <span className="edit">
          <a rel="nofollow" href={state.editUrl}>
            edit
          </a>
        </span>
      );
      if (state.isDraft) {
        draftFlag = <span className="draft-flag">Draft</span>;
        publishButton = (
          <span className="publish">
            <a rel="nofollow" href={state.prePublishUrl}>
              publish
            </a>
          </span>
        );
        deleteButton = (
          <span className="delete">
            <a rel="nofollow" onClick={onDeleteClick} href={state.deleteUrl}>
              delete
            </a>
          </span>
        );
      } else {
        unPublishButton = (
          <span className="unpublish">
            <a href={state.unPublishUrl}>un-publish</a>
          </span>
        );
      }
    }
  }

  return (
    <article
      className={articleClasses}
      data-owner={state.authorId}
      itemProp="relatedItem"
      itemScope
      itemType="http://schema.org/Article"
    >
      <section className="author byline">
        <a rel="me" href={state.author_profile}>
          <div className="profile-pic">
            <img src={state.author_thumb} />
          </div>
          <h1 className="profile-name">
            <span className="hidden">Written by:</span>
            <span>{state.author}</span>
          </h1>
        </a>
      </section>
      <div className="image-container">
        <a href={state.href}>
          <img src={state.spotlightUrl} alt={state.title} />
        </a>
        {comments}
      </div>
      <div className="details">
        <h1 className="item">
          <a itemProp="url" href={state.href}>
            {state.title}
          </a>
        </h1>
        {draftFlag}
        <div className="article-segments">
          <a href={"/search?s=" + state.vehicle}>{state.vehicle}</a>
        </div>
        <div className="menu">
          {lockedButton}
          {editButton}
          {publishButton}
          {deleteButton}
          {unPublishButton}
        </div>
      </div>
    </article>
  );
};
